// The snooker table as the solver sees it: the cushion line (shared/rules.ts CUSHION_LINE, the same walls the
// balls bounced off with Box2D) as segments plus their end points (jaw and corner tips), and the pocket polygons
// (tableGeometry.ts) a ball is potted in when its centre enters one. Pure, no three.js.
import {BALL_RADIUS, CUSHION_LINE} from "../shared/rules";
import {POCKETS} from "../tableGeometry";
import {Boundary, PhysicsParams, Simulation, V2} from "./solver";

export function tableBoundary(): Boundary {
    const segments = [];
    for (let i = 0; i < CUSHION_LINE.length - 1; i++) {
        segments.push({a: [CUSHION_LINE[i][0], CUSHION_LINE[i][1]] as V2, b: [CUSHION_LINE[i + 1][0], CUSHION_LINE[i + 1][1]] as V2});
    }
    const vertices: V2[] = [];
    for (const p of CUSHION_LINE) {
        if (!vertices.some(v => v[0] === p[0] && v[1] === p[1])) vertices.push([p[0], p[1]]);
    }
    const pockets = POCKETS.map(p => p.vertices.map(v => [v.x, v.y] as V2));
    return {segments, vertices, pockets};
}

export function createTableSimulation(params: Partial<PhysicsParams> = {}) {
    return new Simulation(tableBoundary(), {radius: BALL_RADIUS, ...params});
}
